export const ADDRESS_FORM_ID_BY_COUNTRY = {
  COMMON: '0d5dcb6d-1403-4b80-b73e-6d90a2245561',
  US: 'ebe1c447-8fd5-4c7a-8cf1-75b94db68698',
  UY: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  TH: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  TR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SZ: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  ZA: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SE: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SI: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SK: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  RS: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SB: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SG: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SN: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  SD: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  RU: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  RO: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PY: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PT: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PL: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PH: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PE: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PA: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  PK: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  NZ: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  NO: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  NG: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  NL: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  MY: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  MH: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  MX: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  KR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  JP: 'e51fc7b5-0c29-40c6-b2e8-58d9fa5e3c29',
  IT: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  IS: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  IE: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  IN: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  IL: 'bc7a8d54-8df3-47cb-bb9b-3338fd6246e5',
  ID: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  HU: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  HR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  GR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  GB: '3d059d26-8ce8-48ce-9779-b23e42014454',
  FR: 'fbc1fb24-37bc-4c0f-afa4-35e88a43127d',
  ES: 'f0e74759-d378-4ae7-9db7-42b4c7d02094',
  EG: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  DO: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  DK: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  DE: 'c7bde0e2-187e-44e7-8f51-14162259eb2b',
  CZ: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CY: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CO: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CI: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CN: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CL: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CH: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  CA: '2b942888-7d93-41ee-b85c-5705263f9eea',
  CF: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  BR: '3160f799-1ade-455b-87f9-128875ec874e',
  BS: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  BE: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  BG: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  AT: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  AU: '76f1a42e-b609-4c8b-b41a-7ebf2fbb5a56',
  AR: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d',
  AE: 'b7b59987-e5c6-4ec7-a4af-f48318a68a5d'
};
export const DEFAULT_COUNTRY = 'COMMON';
//# sourceMappingURL=constants.js.map